module.exports = __webpack_public_path__ + "static/media/img_0.3413c2bc.png";